import React from "react";
import { Link } from "react-router-dom";
import { MdSearch } from "react-icons/md";
import PageHero from "./PageHero";

const PostgradThesis = () => {
  return (
    <div>
      <PageHero
        kicker="Graduate Thesis"
        title="Research that shapes practice"
        subtitle="Discover postgraduate thesis titles produced by Benadir University scholars across faculties."
      />

      <section className="mx-auto max-w-6xl px-4 py-14 sm:px-6">
        <div className="max-w-3xl space-y-5 text-lg leading-relaxed text-slate-700">
          <p>
            The graduate thesis is a cornerstone of postgraduate study at
            Benadir University. Our repository helps students, supervisors, and
            partners explore completed work across faculties and specialties.
          </p>
          <p>
            Use the university thesis search to browse titles, identify research
            gaps, and connect your proposal to BU&apos;s growing body of
            scholarship.
          </p>
        </div>

        <Link
          to="/research/theses"
          className="mt-10 inline-flex items-center gap-3 bg-[#0863AA] px-6 py-3 text-lg font-semibold text-white transition hover:bg-[#0a4f86]"
        >
          <MdSearch size={24} />
          Search postgraduate thesis titles
        </Link>
      </section>
    </div>
  );
};

export default PostgradThesis;
